import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';

const SettingsIcon: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="settings group w-[1.8rem] h-[1.8rem] text-black dark:text-white cursor-pointer">
        <button onClick={handleOpenModal} title="Settings" className="w-full h-full">
          <svg
            className="h-full w-auto group-hover:text-gray-300 transition-colors duration-200"
            viewBox="0 0 9 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.12466 3.46887C3.84653 3.46887 3.57464 3.55135 3.34339 3.70587C3.11213 3.86039 2.93189 4.08001 2.82545 4.33697C2.71902 4.59393 2.69117 4.87668 2.74543 5.14947C2.79969 5.42225 2.93362 5.67282 3.13029 5.86949C3.32696 6.06616 3.57753 6.20009 3.85031 6.25435C4.1231 6.30861 4.40585 6.28076 4.66281 6.17433C4.91976 6.06789 5.13939 5.88765 5.29391 5.65639C5.44843 5.42513 5.53091 5.15325 5.53091 4.87512C5.52979 4.5025 5.38128 4.14546 5.1178 3.88198C4.85431 3.6185 4.49727 3.46998 4.12466 3.46887V3.46887ZM7.16075 4.87512C7.16002 5.00652 7.15039 5.13772 7.13192 5.26782L7.9878 5.93789C8.02508 5.96867 8.05019 6.0117 8.05866 6.0593C8.06713 6.10689 8.0584 6.15595 8.03403 6.1977L7.22438 7.59551C7.19977 7.63689 7.16135 7.66826 7.11589 7.68412C7.07043 7.69997 7.02083 7.69928 6.97583 7.68217L5.96948 7.27787C5.75993 7.43924 5.53061 7.57316 5.2871 7.67637L5.13663 8.74477C5.12821 8.79262 5.10343 8.83607 5.06653 8.86768C5.02962 8.8993 4.98289 8.91711 4.9343 8.91809H3.31501C3.26731 8.91716 3.22134 8.90009 3.18459 8.86966C3.14784 8.83924 3.1225 8.79726 3.11268 8.75057L2.96222 7.68217C2.71803 7.58015 2.48855 7.44602 2.27983 7.28332L1.27349 7.68762C1.2285 7.70474 1.17892 7.70546 1.13346 7.68964C1.088 7.67382 1.04957 7.64248 1.02493 7.60113L0.215284 6.2035C0.190913 6.16175 0.182182 6.11269 0.190651 6.0651C0.19912 6.01751 0.224237 5.97447 0.261514 5.94369L1.11739 5.27362C1.09914 5.14155 1.08951 5.00844 1.08856 4.87512C1.0893 4.74372 1.09893 4.61252 1.11739 4.48243L0.261514 3.81235C0.224237 3.78157 0.19912 3.73854 0.190651 3.69094C0.182182 3.64335 0.190913 3.59429 0.215284 3.55254L1.02493 2.15473C1.04954 2.11335 1.08796 2.08198 1.13342 2.06613C1.17889 2.05027 1.22848 2.05096 1.27349 2.06807L2.27983 2.47237C2.48939 2.311 2.7187 2.17709 2.96222 2.07387L3.11268 1.00547C3.12111 0.957617 3.14589 0.91417 3.18279 0.882558C3.21969 0.850945 3.26643 0.833129 3.31501 0.832153H4.9343C4.982 0.833082 5.02798 0.850152 5.06472 0.880577C5.10147 0.911002 5.12682 0.952985 5.13663 0.999673L5.2871 2.06807C5.53159 2.17002 5.76137 2.30415 5.97036 2.46692L6.97583 2.06262C7.02081 2.0455 7.07039 2.04478 7.11585 2.0606C7.16131 2.07642 7.19974 2.10776 7.22438 2.14911L8.03403 3.54692C8.0584 3.58867 8.06713 3.63772 8.05866 3.68532C8.05019 3.73291 8.02508 3.77594 7.9878 3.80672L7.13192 4.4768C7.15017 4.60881 7.1598 4.74186 7.16075 4.87512V4.87512Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>

      <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
        <DialogContent className="sm:max-w-lg bg-white dark:bg-[#383838] border-transparent">
          <DialogHeader className="text-center">
            <DialogTitle className="text-[1.6rem] font-semibold text-gray-900 dark:text-white  mb-4">
              Thông báo
            </DialogTitle>
          </DialogHeader>

          <div className="text-center py-6">
            <div className="mx-auto w-16 h-16 bg-yellow-100 dark:bg-yellow-900/20 rounded-full flex items-center justify-center mb-4">
              <svg
                className="w-8 h-8 text-yellow-600 dark:text-yellow-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                />
              </svg>
            </div>

            <p className="text-gray-700 dark:text-gray-300 text-[1.6rem] leading-relaxed">
              Hiện tại chức năng này đang được hoàn thiện. Vui lòng quay lại sau!
            </p>
          </div>

          <div className="flex justify-center gap-3 pt-4">
            <Button
              onClick={handleCloseModal}
              className="px-6 py-2 bg-red-700 hover:bg-red-400 text-white rounded-lg transition-colors duration-200 font-medium text-[1.6rem]"
            >
              Đóng
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SettingsIcon;
